import React from "react";
import { FormWrapProps } from "components/atoms/FormWrap/types";
import { Container } from "components/atoms/FormWrap/styles";

const FormWrap: React.FC<FormWrapProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default FormWrap;
